import { atom } from 'jotai';
const codeAtom = atom('');
export { codeAtom };
